import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RecordPaymentService {
  busSvcURL = '';
  OBRebookAgent = '';
  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public AuthorizePayment(
    rebuid: number | undefined,
    authOnly: boolean,
    folioId: string | undefined,
    amt: number,
    eventId: Int16Array | undefined,
    zip: string,
    firstName: string,
    lastName: string,
    opaqueDataVal: string
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const paymentitems: JSON = <JSON>(<unknown>{
      bookingId: rebuid,
      authOnly: authOnly,
      folioId: folioId,
      amt: amt,
      eventId: eventId,
      zip: zip,
      firstName: firstName,
      lastName: lastName,
      opaqueDataVal: opaqueDataVal,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'AuthorizePayment',
      JSON.stringify(paymentitems),
      {
        headers: headers,
      }
    );
  }
}
